<template>
  <div id="app" >
    <Navbar></Navbar>
    <div class="div-route" v-bind:class="{'isMobile': window.isMobile == true}"><router-view/></div>
    <div class="to-top" @click="document.body.scrollTop = 0" v-if="window.isMobile">
      <i class="material-icons">keyboard_arrow_up</i>
    </div>
    <footer class="text-muted">
      <div class="container">
        <div>
          {{$t("MainPage.CDCName")}} Copyright 2018 All right reserved.
        </div>
        <div>
          <a href="http://www.cdc.gov.tw" target="blank">{{$t("MainPage.CDCGlobalWebSite")}}</a> | {{$t("MainPage.FreeLine")}}1922、0800-00-1922
        </div>
      </div>
    </footer>

    <b-modal
      v-model="modalShow"
      centered
      ok-only
      hide-footer
      header-class="intro-header"
      :hide-header-close="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <div slot="modal-header" class="w-100">
        <div class="div-contorl-intro" style="position:absolute; top:40%; left: 0; z-index:10; cursor: pointer;" @click="changeIntro(-1)" v-if="focusIntroItem != 1">
          <i class="material-icons" style=" font-size: 32px;">keyboard_arrow_left</i>
        </div>
        <div class="div-contorl-intro" style="position:absolute; top:40%; right: 0; z-index:10; cursor: pointer;" @click="changeIntro(1)" v-if="focusIntroItem != 3">
          <i class="material-icons" style=" font-size: 32px;">keyboard_arrow_right</i>
        </div>
        <div class="row intro" v-bind:class="IntroStatus">
          <!--v-on:touchstart="onTouchStart($event)"-->
          <div class="item col-sm-4" v-on:touchstart="setTouchStart($event)" v-on:touchmove="setTouchMove($event)" >
            <div class="image a"></div>
            <div class="describe">
              <div class="title text-center">{{$t("MainPage.Cards.first.title")}}</div>
              <div class="content" v-html="$t('MainPage.Cards.first.describe')"></div>
            </div>
          </div>
          <div class="item col-sm-4" v-on:touchstart="setTouchStart($event)" v-on:touchmove="setTouchMove($event)" >
            <div class="image b"></div>
            <div class="describe">
              <div class="title text-center">{{$t("MainPage.Cards.second.title")}}</div>
              <div class="content">
                {{$t("MainPage.Cards.second.describe")}}
              </div>
            </div>
          </div>
          <div class="item col-sm-4" v-on:touchstart="setTouchStart($event)" v-on:touchmove="setTouchMove($event)" >
            <div class="image c"></div>
            <div class="describe">
              <div class="title text-center">{{$t("MainPage.Cards.third.title")}}</div>
              <div class="content">
                {{$t("MainPage.Cards.third.describe")}}
              </div>
            </div>
          </div>
        </div>
        <div class="row div-control-intro-dot">
          <div @click="changeIntro(1, true)" v-bind:class="{'focus': focusIntroItem == 1}">
            <i class="material-icons">fiber_manual_record</i>
          </div>
          <div @click="changeIntro(2, true)" v-bind:class="{'focus': focusIntroItem == 2}">
            <i class="material-icons">fiber_manual_record</i>
          </div>
          <div @click="changeIntro(3, true)" v-bind:class="{'focus': focusIntroItem == 3}">
            <i class="material-icons">fiber_manual_record</i>
          </div>
        </div>
        <div class="statement" v-html="$t('Usage.Notice.itemWithNotice')">　　</div>
      </div>
      <div class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click="closeModal">
          {{$t('OK')}}
        </b-btn>
      </div>
    </b-modal>

  </div>
</template>

<script>
import Navbar from "./components/Navbar";
export default {
  name: "App",
  components: { Navbar },
  data() {
    return {
      document: document,
      modalShow: true,
      focusIntroItem: 1,
      window: window,
      touchStart: { point: undefined, isTrigger: false }
    };
  },
  methods: {
    closeModal: function() {
      this.modalShow = false;

      this.$ga.event({
        eventCategory: "MainPage",
        eventAction: "OK"
      });
    },
    changeIntro: function(value, forceChange) {
      if (forceChange) {
        this.focusIntroItem = value;
      } else {
        this.focusIntroItem += value;

        if (this.focusIntroItem < 1) this.focusIntroItem = 1;
        if (this.focusIntroItem > 3) this.focusIntroItem = 3;
      }
    },
    setTouchStart: function(event) {
      this.touchStart.point = [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
      ];
      this.touchStart.isTrigger = false;
      //console.log([event.changedTouches[0].clientX, event.changedTouches[0].clientY])
    },
    setTouchMove: function(event) {
      let point = [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
      ];
      let diff = point[0] - this.touchStart.point[0];

      if (this.touchStart.isTrigger == false && Math.abs(diff) > 50) {
        if (diff > 0) {
          this.changeIntro(-1);
        } else {
          this.changeIntro(1);
        }

        this.touchStart.isTrigger = true;
      }
    }
  },
  computed: {
    IntroStatus: function() {
      switch (this.focusIntroItem) {
        case 1:
          return "a";
          break;
        case 2:
          return "b";
          break;
        case 3:
          return "c";
          break;

        default:
          return "a";
          break;
      }
      return "a";
    }
  }
};
</script>

<style>
@import "bootstrap/dist/css/bootstrap.css";
@import "bootstrap-vue/dist/bootstrap-vue.css";

body {
  background-color: #292929 !important;
  font-family: "Roboto", "Noto Sans TC", sans-serif !important;
}

body::-webkit-scrollbar {
  width: 12px;
  height: 8px;
}

body::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.4);
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1),
    inset 0 -1px 0 rgba(0, 0, 0, 0.07);
  -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1),
    inset 0 -1px 0 rgba(0, 0, 0, 0.07);
}

.tooltip {
  pointer-events: none;
}

.tooltip.bs-tooltip-auto[role^="right"] .arrow::before,
.tooltip.bs-tooltip-right .arrow::before {
  content: "";
  border-right-color: #717171;
}

.tooltip.bs-tooltip-auto[x-placement^="top"] .arrow::before,
.tooltip.bs-tooltip-top .arrow::before {
  content: "";
  border-top-color: #717171;
}
.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  background-color: #717171 !important;
  border-radius: 0.25rem;
}

@media (min-width: 992px) {
  .modal-lg {
    max-width: 1024px;
  }
}
</style>

<style lang="scss">
@import "./scss/main.scss";

.text-muted {
  margin-top: 32px;
  margin-bottom: 0px;
  padding-top: 16px;
  padding-bottom: 16px;
  background-color: #000;

  font-size: 14px;
  text-align: center;
  a {
    color: #9e9e9e;
    font-weight: 600;
    &:hover {
      color: #9e9e9e;
    }
  }
}

@media (min-width: 992px) {
  text-align: left;
}
@media screen and (max-width: 600px) {
  .intro-header {
    position: relative;
    overflow-x: hidden;

    max-height: 70vh;
  }
  .div-contorl-intro {
    display: block !important;
  }
  .div-control-intro-dot {
    display: flex !important;
    padding: 8px 15px 0px 15px;
    align-items: center;
    justify-content: center;
    div {
      cursor: pointer;
      margin: 0px 4px;
      &.focus {
        color: #5e5e5e;
      }
      color: #d1d1d1;
      i {
        font-size: 16px;
      }
    }
  }
  .intro {
    position: relative;

    flex-wrap: initial;
    overflow-x: hidden;
    width: 2000px;
    transform: translate3d(0px, 0px, 0px);
    &.a {
      transform: translate3d(0px, 0px, 0px);
      transition-duration: 0.5s;
    }
    &.b {
      transform: translate3d(calc(-100vw + 30px), 0px, 0px);
      transition-duration: 0.5s;
    }
    &.c {
      transform: translate3d(calc(-200vw + 60px), 0px, 0px);
      transition-duration: 0.5s;
    }

    .item {
      width: calc(100vw - 30px);
      flex: none;
    }
  }
}
.div-contorl-intro {
  display: none;
}
.div-control-intro-dot {
  display: none;
}
.intro {
  .item {
    @include xs-width() {
      .image {
        height: 150px;
      }
    }

    @include sm-width() {
      .image {
        height: 175px;
      }
    }

    @include md-width() {
      .image {
        height: 175px;
      }
    }

    @include lg-width() {
      .image {
        height: 175px;
      }
    }

    @include xl-width() {
      .image {
        height: 175px;
      }
    }

    .image {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      &.a {
        background-image: url("../static/images/Tutorial/Tutorial01.png");
      }
      &.b {
        background-image: url("../static/images/Tutorial/Tutorial02.png");
      }
      &.c {
        background-image: url("../static/images/Tutorial/Tutorial03.png");
      }
    }
    .describe {
      .title {
        font-size: 20px;
        margin: 32px 0px;
        font-weight: 600;
      }
      @include xs-width() {
        .content {
          font-size: 14px;
          padding: 0 12px;
        }
      }
    }
  }
}
.statement {
  font-size: 14px;
  margin-top: 16px;
}

.div-route {
  margin-top: 64px;
  &.isMobile {
    margin-top: 64px;
  }
}
</style>

<style lang="scss" scoped>
.to-top {
  display: flex;

  width: 36px;
  height: 36px;
  position: fixed;
  bottom: 12px;
  right: 12px;

  background-color: rgba(96, 125, 139, 0.7);
  border-radius: 50% 50%;

  cursor: pointer;

  color: #fff;
  vertical-align: middle;
  justify-content: center;

  -moz-user-select: none;
  -webkit-user-select: none;

  .material-icons {
    font-size: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue